import React, { useState } from "react";
import { Container, Button, Typography, Chip, Skeleton } from "@mui/material";
import { formatCurrency } from '../../../utils/Format.js';
import styles from "./clientsDetailsHeaderStyles.js";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Box from "@mui/material/Box";
import { Add, EmptyWallet, Minus } from "iconsax-react";
import ClientsTabBar from "../ClientsTabBar/index.js";
import ClientsAmountCreditsDialog from "../ClientsAmountCreditsDialog/index.js";
import ClientsAmountBalanceDialog from "../ClientsAmountBalanceDialog/index.js";
import { usePermissions } from "../../../hooks/permissions/usePermissions.js";

const ClientsDetailsHeader = ({ idUser, categories, credits, user, balance, isLoading, fetchClientInfo, fetchCategories, fetchClientCredits, fetchClientBalance }) => {

  const [action, setAction] = useState("");
  const [currentTap, setCurrentTap] = useState("3");

  const { hasPermission, hasAllPermissions } = usePermissions();

  const [openDialog, setOpenDialog] = useState(null);

  const handleDialogOpen = (dialogName, action) => {
    setAction(action);
    setOpenDialog(dialogName);
  };

  const handleDialogClose = () => {
    setOpenDialog(null);
  };

  if (!hasPermission("cli_vw")) {
    return (
      <Container sx={styles.mainContainer}>
        <Typography title="No tienes permisos para ver la información del cliente" />
      </Container>
    );
  }

  return (
    <Container style={{ padding: 0 }}>
      <Container style={styles.mainContainer}>

        {isLoading ? (
          <Container sx={styles.skeletonMainContainer}>
            <Skeleton variant="circular" width={60} height={60} />
            <Container sx={styles.skeletonSecondaryContainer}>
              <Skeleton variant="rounded" width={200} height={30} />
              <Skeleton variant="rounded" width={100} height={20} />
            </Container>
          </Container>
        ) : (
          <Container sx={styles.delivererDetailsContainer}>

            <Container sx={styles.delivererDetailsInfoContainer}>
              <Box sx={styles.circleAvatar}>
                <AccountCircleIcon sx={styles.iconCircleAvatar} />
              </Box>
              <Box>
                <Typography sx={styles.title}>
                  {user?.user_name} {user?.maternal_lastname} {user?.paternal_lastname}
                </Typography>
                <Box sx={styles.chipsContainer}>
                  {hasAllPermissions(["cli_vwc", "cli_vw"]) &&<Chip
                    icon={
                      <EmptyWallet size={18} variant="Bold" style={styles.creditsChip} />
                    }
                    sx={{
                      ...styles.creditsChip,
                    }}
                    label={`${formatCurrency(credits?.actual_credits || 0)} Créditos`}
                    size="small"
                  />}
                  { hasAllPermissions(["cli_vwb", "cli_vw"]) && <Chip
                    icon={
                      <EmptyWallet size={18} variant="Bold" style={styles.balanceChip} />
                    }
                    sx={{
                      ...styles.balanceChip,
                    }}
                    label={`${formatCurrency(balance?.actual_balance || 0)} Saldo`}
                    size="small"
                  />}
                </Box>
              </Box>
            </Container>

            <Box
              sx={{
                display: { xs: "none", md: "flex", gap: 8 },
              }}
            >
              {/* Remover */}
              {((currentTap === "1" && hasPermission("cli_rmc") && hasPermission("cli_vw")) ||
                (currentTap === "2" && hasPermission("cli_rmb") && hasPermission("cli_vw"))) && (
                <Button
                  variant="contained"
                  startIcon={<Minus />}
                  style={{ width: '210px'}}
                  onClick={() =>
                    handleDialogOpen(
                      currentTap === "1" ? "CreditsAmountDialog" : "BalanceAmountDialog",
                      "Remover"
                    )
                  }
                  sx={styles.activeButton}
                >
                  {currentTap === "1" ? "Remover créditos" : "Remover saldo"}
                </Button>
              )}

              {/* Agregar */}
              {((currentTap === "1" && hasPermission("cli_adc") && hasPermission("cli_vw")) ||
                (currentTap === "2" && hasPermission("cli_adb") && hasPermission("cli_vw"))) && (
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  style={{ width: '210px'}}
                  onClick={() =>
                    handleDialogOpen(
                      currentTap === "1" ? "CreditsAmountDialog" : "BalanceAmountDialog",
                      "Agregar"
                    )
                  }
                  sx={styles.activeButton}
                >
                  {currentTap === "1" ? "Agregar créditos" : "Agregar saldo"}
                </Button>
              )}
            </Box>
          </Container>
        )}

        <Box
          sx={{
            display: { xs: "flex", md: "none", gap: 8 },
            marginTop: "8px",
          }}
        >
          {((currentTap === "1" && hasPermission("cli_rmc") && hasPermission("cli_vw")) ||
            (currentTap === "2" && hasPermission("cli_rmb") && hasPermission("cli_vw"))) && (
            <Button
              variant="contained"
              startIcon={<RemoveIcon />}
              onClick={() =>
                handleDialogOpen(
                  currentTap === "1" ? "CreditsAmountDialog" : "BalanceAmountDialog",
                  "Remover"
                )
              }
              sx={{ ...styles.activeButton, width: "100%" }}
            >
              {currentTap === "1" ? "Remover créditos" : "Remover saldo"}
            </Button>
          )}

          {((currentTap === "1" && hasPermission("cli_adc") && hasPermission("cli_vw")) ||
            (currentTap === "2" && hasPermission("cli_adb") && hasPermission("cli_vw"))) && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() =>
                handleDialogOpen(
                  currentTap === "1" ? "CreditsAmountDialog" : "BalanceAmountDialog",
                  "Agregar"
                )
              }
              sx={{ ...styles.activeButton, width: "100%" }}
            >
              {currentTap === "1" ? "Agregar créditos" : "Agregar saldo"}
            </Button>
          )}
        </Box>
      </Container>

      <ClientsTabBar user={user} fetchClientInfo={fetchClientInfo} categories={categories} credits={credits} balance={balance} isLoading={isLoading} currentTap={currentTap} setCurrentTap={setCurrentTap} />

      <ClientsAmountCreditsDialog
        open={openDialog === "CreditsAmountDialog"}
        action={action}
        idUser={idUser}
        user={credits}
        fetchClientCredits={fetchClientCredits}
        onClose={handleDialogClose}
      />

      <ClientsAmountBalanceDialog
        open={openDialog === "BalanceAmountDialog"}
        action={action}
        idUser={idUser}
        user={balance}
        fetchClientBalance={fetchClientBalance}
        onClose={handleDialogClose}
      />
    </Container>
  );
};

export default ClientsDetailsHeader;
